// Central business data for Nagar Glass

export const BRAND = {
  name: "Nagar Glass",
  phoneDisplay: "+91 92287 10567",
  phoneRaw: "+919228710567",
  phoneTel: "+919228710567",
  whatsappNumber: "919228710567",
  email: "nagarglass7@gmail.com",
  city: "Ahmedabad",
  experience: "15+",
  logo: "https://customer-assets-jt897jd0.emergentagent.net/job_nagar-glass-premium/artifacts/guqk1dn3_Interlocking%20NVG%20Monogram%20Logo.png",
  ownerPhoto: "https://customer-assets-jt897jd0.emergentagent.net/job_nagar-glass-premium/artifacts/9l9rvno0_WhatsApp%20Image%202026-08-03%20at%2015.01.54.jpeg",
  ownerName: "Mr. Nagar",
  ownerTitle: "Founder & Master Craftsman",
  whatsappMessage:
    "Hi Nagar Glass, I found your website and would like to discuss a glass/aluminium requirement.",
};

export const whatsappLink = (msg = BRAND.whatsappMessage) =>
  `https://wa.me/${BRAND.whatsappNumber}?text=${encodeURIComponent(msg)}`;

export const telLink = () => `tel:${BRAND.phoneTel}`;

export const ADDRESSES = [
  {
    label: "Narol Showroom",
    lines:
      "Shop S/227, Rashmi South Park, Opp. Karnavati 3, Near Siddhi Flora, Narol-Aslali Highway, Narol, Ahmedabad",
    mapEmbed:
      "https://www.google.com/maps?q=Rashmi+South+Park+Narol+Aslali+Highway+Ahmedabad&hl=en&z=16&output=embed",
    mapLink: "https://share.google/hiWEf2iGuSPH9htbU",
  },
  {
    label: "Isanpur Branch",
    lines:
      "Shradha Complex, 3, Opp. Asha Society, Isanpur, Ahmedabad, Gujarat 382443",
    mapEmbed:
      "https://www.google.com/maps?q=Shradha+Complex+Opp+Asha+Society+Isanpur+Ahmedabad+382443&hl=en&z=16&output=embed",
    mapLink: "https://www.google.com/maps/search/?api=1&query=Shradha+Complex+Isanpur+Ahmedabad+382443",
  },
];

// Curated architectural imagery
export const IMG = {
  heroFacade:
    "https://images.unsplash.com/photo-1481026469463-66327c86e544?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBnbGFzcyUyMGZhY2FkZSUyMGFyY2hpdGVjdHVyZXxlbnwwfHx8fDE3ODUzMzE2NjB8MA&ixlib=rb-4.1.0&q=85",
  shower:
    "https://images.unsplash.com/photo-1639751898256-e80ef909ea8d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxtaW5pbWFsaXN0JTIwc2hvd2VyJTIwZW5jbG9zdXJlJTIwYmF0aHJvb218ZW58MHx8fHwxNzg1MzMxNjYxfDA&ixlib=rb-4.1.0&q=85",
  aluminium:
    "https://images.unsplash.com/photo-1724582586529-62622e50c0b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxibGFjayUyMGFsdW1pbml1bSUyMHdpbmRvd3MlMjBtb2Rlcm4lMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODUzMzE2NjF8MA&ixlib=rb-4.1.0&q=85",
  railing:
    "https://images.unsplash.com/photo-1683471538809-d6b7a0edfbb0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDZ8MHwxfHNlYXJjaHwzfHxnbGFzcyUyMHJhaWxpbmclMjBtb2Rlcm4lMjBzdGFpcnN8ZW58MHx8fHwxNzg1MzMxNjYxfDA&ixlib=rb-4.1.0&q=85",
  office:
    "https://images.unsplash.com/photo-1705909773171-4ba952b9c0af?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjBnbGFzcyUyMHBhcnRpdGlvbnxlbnwwfHx8fDE3ODI1ODQwMDJ8MA&ixlib=rb-4.1.0&q=85",
  mirror:
    "https://images.unsplash.com/photo-1784653548747-dfe7370326b3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDN8MHwxfHNlYXJjaHw0fHxpbnRlcmlvciUyMGRlc2lnbiUyMGxlZCUyMG1pcnJvcnxlbnwwfHx8fDE3ODUzMzE2NjB8MA&ixlib=rb-4.1.0&q=85",
  craftsman:
    "https://images.unsplash.com/photo-1730791480388-ac9930bf2636?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHw0fHxjcmFmdHNtYW4lMjBpbnN0YWxsaW5nJTIwZ2xhc3N8ZW58MHx8fHwxNzg1MzMxNjYwfDA&ixlib=rb-4.1.0&q=85",
  storefront:
    "https://images.unsplash.com/photo-1441986300917-64674bd600d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  interior:
    "https://images.unsplash.com/photo-1618221195710-dd6b41faaea6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  facade2:
    "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  partition2:
    "https://images.unsplash.com/photo-1497366754035-f200968a6e72?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  bath2:
    "https://images.unsplash.com/photo-1620626011761-996317b8d101?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  living:
    "https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
  staircase:
    "https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?crop=entropy&cs=srgb&fm=jpg&q=85&w=1600",
};

// Home page featured services (from nagarglass.com)
export const HOME_SERVICES = [
  { title: "Aluminium Windows & Doors", img: IMG.aluminium, desc: "Slim-profile sliding and openable systems built to measure." },
  { title: "Architectural Glass", img: IMG.heroFacade, desc: "Glazing and facade glass for modern homes and buildings." },
  { title: "Shower Enclosures", img: IMG.shower, desc: "Frameless toughened glass enclosures and shower screens." },
  { title: "LED Mirrors", img: IMG.mirror, desc: "Backlit and custom-cut mirrors for bathrooms and vanities." },
  { title: "Glass Partitions", img: IMG.office, desc: "Clean partitions for offices, cabins and interior spaces." },
  { title: "Glass Railings", img: IMG.railing, desc: "Balcony, terrace and staircase railings in toughened glass." },
  { title: "Glass Storefronts", img: IMG.storefront, desc: "Frameless storefronts and entrances for retail spaces." },
  { title: "Toughened Glass", img: IMG.facade2, desc: "Tempered glass cut, polished and fitted to specification." },
];

// Residential services — full list from nagarglass.com
export const RESIDENTIAL_SERVICES = [
  { title: "Aluminium Windows & Doors", img: IMG.aluminium, desc: "Custom aluminium window and door systems fabricated and installed for homes, with clean sightlines and durable hardware." },
  { title: "Sliding Windows & Doors", img: IMG.living, desc: "Smooth-running sliding systems for balconies, terraces and living spaces, with large glass panels and minimal frames." },
  { title: "Architectural Glass", img: IMG.heroFacade, desc: "Glazing solutions for facades, openings and feature walls, selected for clarity, strength and finish." },
  { title: "Toughened Glass", img: IMG.facade2, desc: "Tempered safety glass cut, polished and fitted to exact measurements for doors, partitions and railings." },
  { title: "Shower Enclosures", img: IMG.shower, desc: "Frameless and semi-frameless shower enclosures in toughened glass, made to fit any bathroom layout." },
  { title: "LED Mirrors", img: IMG.mirror, desc: "Backlit LED mirrors in custom shapes and sizes for bathrooms, vanities and dressing areas." },
  { title: "Custom Mirrors", img: IMG.interior, desc: "Bevelled, framed and shaped mirrors made to your drawing for wardrobes, walls and interiors." },
  { title: "Glass Partitions", img: IMG.partition2, desc: "Interior glass partitions that divide space without losing daylight or openness." },
  { title: "Glass Railings", img: IMG.railing, desc: "Toughened glass railings with stainless steel or aluminium hardware for balconies and terraces." },
  { title: "Balcony Glass", img: IMG.facade2, desc: "Balcony glazing and enclosures that protect from dust and weather while keeping the view." },
  { title: "Staircase Glass", img: IMG.staircase, desc: "Frameless staircase railings and glass balustrades finished with precision." },
  { title: "Glass Doors", img: IMG.interior, desc: "Frameless and framed glass doors with quality patch fittings, floor springs and handles." },
  { title: "Mosquito Net Solutions", img: IMG.aluminium, desc: "Sliding, pleated and roll-up mosquito nets in aluminium frames for windows, doors and balconies — dust and insect protection without blocking air." },
  { title: "Aluminium Frame Mirrors", img: IMG.mirror, desc: "Mirrors set in slim aluminium frames in your choice of finish, made to size for bathrooms, wardrobes and dressing areas." },
  { title: "Slim Profile Systems", img: IMG.living, desc: "Ultra-slim aluminium profiles for sliding and openable systems — maximum glass, minimum frame, clean modern sightlines." },
  { title: "Glass Film", img: IMG.office, desc: "Frosted, tinted, one-way and decorative films applied on glass for privacy, heat control and safety." },
  { title: "Glass Digital Printing", img: IMG.partition2, desc: "Digitally printed glass for backsplashes, wardrobe shutters and feature walls — any pattern, photo or colour on toughened glass." },
  { title: "Digital Nameplates", img: IMG.interior, desc: "Backlit glass and acrylic nameplates with custom lettering for homes, apartments and entrances." },
  { title: "Glass Racks & Shelves", img: IMG.bath2, desc: "Toughened glass racks and shelves with quality brackets for bathrooms, kitchens and display niches." },
  { title: "Custom Glass Work", img: IMG.living, desc: "One-off glass and aluminium work fabricated to your design, measurement and site condition." },
];

// Commercial services — full list from nagarglass.com
export const COMMERCIAL_SERVICES = [
  { title: "Glass Storefronts", img: IMG.storefront, desc: "Frameless and aluminium-framed storefronts that give retail spaces a clean, premium street presence." },
  { title: "Office Glass Partitions", img: IMG.office, desc: "Single and double-glazed office partitions for meeting rooms, workstations and reception areas." },
  { title: "Glass Cabins", img: IMG.partition2, desc: "Executive glass cabins with frameless doors, delivering privacy without closing off the floor plate." },
  { title: "Aluminium Windows & Doors", img: IMG.aluminium, desc: "Commercial-grade aluminium systems engineered for high usage and larger spans." },
  { title: "Commercial Glazing", img: IMG.heroFacade, desc: "Glazing work for offices, institutions and commercial buildings, handled end to end." },
  { title: "Toughened Glass", img: IMG.facade2, desc: "Safety glass for doors, partitions, counters and facades, cut to project specification." },
  { title: "Frameless Glass Doors", img: IMG.interior, desc: "Entrance and internal frameless doors with premium fittings and smooth operation." },
  { title: "Showroom Glass", img: IMG.storefront, desc: "Display glazing and showroom glass work that keeps products visible and well lit." },
  { title: "Glass Railings", img: IMG.railing, desc: "Railings and balustrades for atriums, mezzanines and commercial staircases." },
  { title: "Architectural Glass", img: IMG.heroFacade, desc: "Facade and feature glass for contemporary commercial architecture." },
  { title: "Spider Fitting Glazing", img: IMG.facade2, desc: "Spider fitting and structural glazing with stainless steel spiders for lobbies, facades and canopies." },
  { title: "Slim Profile Systems", img: IMG.aluminium, desc: "Slim aluminium profile systems for commercial glazing where sightlines and spans both matter." },
  { title: "Glass Film & Branding", img: IMG.office, desc: "Frosted, tinted and printed films on office glass for privacy, sun control and branding bands." },
  { title: "Glass Digital Printing", img: IMG.partition2, desc: "Digitally printed glass panels for signage, feature walls and showroom graphics." },
  { title: "Digital Nameplates & Signage", img: IMG.interior, desc: "Backlit glass nameplates and signage for offices, clinics and commercial entrances." },
  { title: "Glass Racks & Display Shelves", img: IMG.storefront, desc: "Toughened glass display racks and shelving for retail counters and showrooms." },
  { title: "Mosquito Net Solutions", img: IMG.aluminium, desc: "Aluminium-framed mosquito net systems for commercial windows, pantries and service areas." },
  { title: "Custom Glass & Aluminium Solutions", img: IMG.office, desc: "Bespoke fabrication for requirements that do not fit a standard system." },
];

// Glass Products & Processing — specialised offerings
export const PROCESSING_SERVICES = [
  { title: "EVA Laminated Glass", img: IMG.facade2, desc: "EVA interlayer laminated glass with excellent bonding and moisture resistance — used for safety glazing, railings, partitions and overhead applications." },
  { title: "EVA Fabric Laminated Glass", img: IMG.partition2, desc: "Decorative glass with fabric, mesh or textile interlayers laminated between panels — for feature walls, shutters and premium interior partitions." },
  { title: "Flat Toughened Glass", img: IMG.heroFacade, desc: "Flat tempered safety glass in multiple thicknesses, cut, drilled, notched and polished to your drawing before toughening." },
  { title: "Bend Toughened Glass", img: IMG.staircase, desc: "Curved toughened glass fabricated to the required radius for counters, lifts, curved facades and cabins." },
  { title: "Laminated Toughened Glass", img: IMG.railing, desc: "Two or more toughened panels bonded with an interlayer for maximum strength and safety in overhead, railing and facade glazing." },
  { title: "Laminated Glass", img: IMG.office, desc: "Standard laminated safety glass with clear or tinted interlayers for security, sound reduction and UV control." },
];

// Projects gallery
export const PROJECT_CATEGORIES = [
  "All",
  "Residential",
  "Commercial",
  "Shower",
  "Mirrors",
  "Storefronts",
  "Aluminium",
];

export const PROJECTS = [
  {
    id: "p1",
    title: "Riverside Residence Facade",
    category: "Residential",
    location: "Ahmedabad",
    img: IMG.heroFacade,
    desc: "Full-height architectural glazing and slim aluminium framing for a contemporary private home.",
  },
  {
    id: "p2",
    title: "Corporate Glass Cabins",
    category: "Commercial",
    location: "Ahmedabad",
    img: IMG.office,
    desc: "Frameless office partitions and glass cabins designed for a bright, modern workplace.",
  },
  {
    id: "p3",
    title: "Frameless Shower Suite",
    category: "Shower",
    location: "Ahmedabad",
    img: IMG.shower,
    desc: "Precision-fitted frameless shower enclosure with toughened glass and premium hardware.",
  },
  {
    id: "p4",
    title: "Backlit LED Vanity Mirrors",
    category: "Mirrors",
    location: "Ahmedabad",
    img: IMG.mirror,
    desc: "Custom LED mirrors with anti-fog heating for a hospitality-grade bathroom.",
  },
  {
    id: "p5",
    title: "Retail Storefront Glazing",
    category: "Storefronts",
    location: "Ahmedabad",
    img: IMG.storefront,
    desc: "Large-format storefront glass creating a striking, secure retail presence.",
  },
  {
    id: "p6",
    title: "Black Aluminium Window System",
    category: "Aluminium",
    location: "Ahmedabad",
    img: IMG.aluminium,
    desc: "Matte-black slimline aluminium windows and doors for a modern interior.",
  },
  {
    id: "p7",
    title: "Staircase Glass Balustrade",
    category: "Residential",
    location: "Ahmedabad",
    img: IMG.railing,
    desc: "Minimal glass railing system turning the staircase into a sculptural centrepiece.",
  },
  {
    id: "p8",
    title: "Showroom Display Partition",
    category: "Commercial",
    location: "Ahmedabad",
    img: IMG.partition2,
    desc: "Floor-to-ceiling glass partitions defining zones without losing openness.",
  },
  {
    id: "p9",
    title: "Spa Bathroom Enclosure",
    category: "Shower",
    location: "Ahmedabad",
    img: IMG.bath2,
    desc: "Semi-frameless enclosure with a clean, watertight, easy-clean finish.",
  },
  {
    id: "p10",
    title: "Sliding Aluminium Doors",
    category: "Aluminium",
    location: "Ahmedabad",
    img: IMG.living,
    desc: "Wide-span sliding aluminium doors connecting living space to the outdoors.",
  },
  {
    id: "p11",
    title: "Boutique Storefront",
    category: "Storefronts",
    location: "Ahmedabad",
    img: IMG.facade2,
    desc: "Elegant glazed facade tailored to a premium boutique brand identity.",
  },
  {
    id: "p12",
    title: "Statement Feature Mirror",
    category: "Mirrors",
    location: "Ahmedabad",
    img: IMG.interior,
    desc: "Custom-shaped feature mirror crafted to the interior designer's specification.",
  },
];

// YouTube Shorts (real vertical reels)
export const SHORTS = [
  { id: "s1", youtube: "oId9KPDsV04", title: "Frameless Shower Fitting", cover: IMG.shower },
  { id: "s2", youtube: "9J8zzCouiDI", title: "Aluminium Window Install", cover: IMG.aluminium },
  { id: "s3", youtube: "JX3drFM4MU4", title: "Glass Railing Reveal", cover: IMG.railing },
  { id: "s4", youtube: "ND2z63prTh8", title: "Office Partition Detail", cover: IMG.office },
  { id: "s5", youtube: "yta82oAhxhM", title: "LED Mirror Glow", cover: IMG.mirror },
  { id: "s6", youtube: "K7_6NjhnQ08", title: "Storefront Time-lapse", cover: IMG.storefront },
];

// Trusted brands we source from
export const BRANDS = [
  { name: "Ozone", desc: "Architectural hardware & fittings" },
  { name: "Inox", desc: "Glass fittings & accessories" },
  { name: "A-Win", desc: "Aluminium window systems" },
  { name: "Saint Gobain", desc: "Glass & mirrors" },
  { name: "Modiguard", desc: "Float & toughened glass" },
  { name: "Gopal Glass", desc: "Designer & textured glass" },
];

export const REELS = SHORTS;

export const WHY_US = [
  {
    n: "01",
    title: "15+ Years of Experience",
    desc: "More than a decade and a half fabricating and installing glass and aluminium across Ahmedabad and nearby areas.",
  },
  {
    n: "02",
    title: "Custom Made Solutions",
    desc: "Every project is measured, fabricated and finished to your exact dimensions and design intent.",
  },
  {
    n: "03",
    title: "Residential & Commercial Expertise",
    desc: "From private homes to offices, showrooms and retail — we work fluently across both worlds.",
  },
  {
    n: "04",
    title: "Professional Installation",
    desc: "Careful, precise on-site installation that protects your space and delivers a flawless finish.",
  },
];

export const PROCESS = [
  { n: "01", title: "Consultation", desc: "We understand your space, requirement and design vision." },
  { n: "02", title: "Measurement", desc: "Precise on-site measurement to ensure a perfect, safe fit." },
  { n: "03", title: "Fabrication", desc: "Your glass and aluminium is cut, toughened and finished to spec." },
  { n: "04", title: "Installation", desc: "Clean, professional installation with a flawless final finish." },
];
